import React from 'react';
import { Box, Link, Theme, useMediaQuery } from '@mui/material';
import NextLink from 'next/link';

import Dialog from '../Dialog';

import { ImageDialogProps } from './props';

export const ImageDialog: React.FC<ImageDialogProps> = (props) => {
  const { open, onClose, imageUrl, type, title, imageList, ...dialogProps } =
    props;
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('sm')
  );

  const isPdfChecking = (type: string) => {
    return type === '.pdf' || type === 'application/pdf' || type === 'pdf';
  };

  const renderImage = () => {
    if (!imageUrl && !imageList) return null;
    if (imageList) {
      return (
        <>
          {imageList.map((val, index) => {
            if (isPdfChecking(val?.mimeType ?? 'application/pdf')) {
              return (
                <Link component={NextLink} href={val.fileUrl} target={'_blank'}>
                  {val.fileName}
                </Link>
              );
            }
            return (
              <img
                width={'100%'}
                height={'auto'}
                src={val.fileUrl}
                alt={'dialog'}
              />
            );
          })}
        </>
      );
    }
    if (isPdfChecking(type || (imageUrl?.split('.')?.slice(-1)[0] ?? ''))) {
      if (isMobile) {
        return (
          <Link component={NextLink} href={imageUrl} target={'_blank'}>
            Download SSM
          </Link>
        );
      }
      return (
        <Box sx={{ height: '80vh' }}>
          <embed width={'100%'} height={'100%'} src={imageUrl} />
        </Box>
      );
    }
    return <img width={'100%'} height={'auto'} src={imageUrl} alt={'dialog'} />;
  };

  return (
    <Dialog
      title={title}
      open={open}
      onClose={onClose}
      contentAlignment="left"
      maxWidth="sm"
      fullWidth
      disableButton
      {...dialogProps}
    >
      {renderImage()}
    </Dialog>
  );
};

export * from './props';
export default ImageDialog;
